import { render } from "./NyuukaDetailPage.vue?vue&type=template&id=4892a502"
import script from "./NyuukaDetailPage.vue?vue&type=script&lang=js"
export * from "./NyuukaDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1508006177/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__